<div class="card bg-secondary">
  <div class="card-body p-1">
    <div [attr.data-key]="form.get('type')?.value">
      <form [formGroup]="form">
        <!-- COLLAPSE TOGGLE -->
        <div class="d-flex" (click)="collapsetoggle()" [attr.aria-expanded]="isOpen">
          <span style="margin-top: -3px" class="material-icons lh-30 align-middle pr-2 c-close display-inline">
            settings_suggest
          </span>
          <p class="mb-0 lh-30 align-middle">
            {{ form.get("name")?.value }} - {{ form.get("type")?.value }}
          </p>
        </div>

        <!-- COLLAPSE CONTENT -->
        <div class="collapse p-1" [class.show]="isOpen" [id]="'automationactioncollapse' + automationAction.actionId">
          <!-- STATIC FIELDS -->
          <div class="form-group">
            <label>{{ "projectautomation.order" | trans }}</label>
            <input type="text" class="form-control" formControlName="sortOrder"
              placeholder="{{ 'projectautomation.order' | trans }}..." />
          </div>

          <div class="form-group">
            <label>{{ "projectautomation.name" | trans }}</label>
            <input type="text" class="form-control" formControlName="name"
              placeholder="{{ 'projectautomation.nameplace' | trans }}" />
          </div>

          <div class="form-group">
            <label>{{ "projectautomation.desc" | trans }}</label>
            <input type="text" class="form-control" formControlName="description"
              placeholder="{{ 'projectautomation.descplace' | trans }}" />
          </div>

          <div class="form-group">
            <label>{{ "projectautomation.type" | trans }}</label>
            <select class="form-control" formControlName="type">
              <option [ngValue]="''" disabled hidden>
                {{ "orgprojectadd.choose" | trans }}
              </option>
              <option [ngValue]="'task.add'">Add task</option>
              <option [ngValue]="'project.create'">Create project</option>
              <option [ngValue]="'customer.users.activateandinvite'">
                Activate and invite customer users
              </option>
              <option [ngValue]="'project.createfromtemplate'">
                Create from template
              </option>
              <option [ngValue]="'customer.users.assigntotasks'">
                Assign customer user to tasks
              </option>
              <option [ngValue]="'http.request'">HTTP request</option>

              <option [ngValue]="'customer.users.list'">Customer user list</option>
              <option [ngValue]="'lambda.invoke'">Envoke custom code</option>
              <option [ngValue]="'customer'">Get customer</option>
              <!-- Add more types as needed -->
            </select>
          </div>

          <!-- DYNAMIC FIELDS -->
          <div class="form-group" *ngFor="let field of fieldConfig; trackBy: trackByFieldKey">
            <ng-container *ngIf="form.get(field.key) as fieldGroup">
              <app-automationfield [name]="field.key" [label]="field.label" [tooltip]="field.tooltip"
                [helperText]="field.helperText" [formGroup]="fieldGroup" [options]="getFieldOptionValues(field)"
                [placeholder]="field.placeholder" [type]="field.type"
                [lastrun]="automation?.lastrun"></app-automationfield>
            </ng-container>

            <!--<label [for]="field.key">{{ field.label }}</label>

            <ng-container [ngSwitch]="field.type">
              <input *ngSwitchCase="'text'" type="text" class="form-control" [formControlName]="field.key"
                [placeholder]="field.placeholder" [id]="field.key" />

              <input *ngSwitchCase="'date'" type="date" class="form-control" [formControlName]="field.key"
                [id]="field.key" />

              <input *ngSwitchCase="'number'" type="number" class="form-control" [formControlName]="field.key"
                [id]="field.key" />

              <select *ngSwitchCase="'select'" class="form-control" [formControlName]="field.key" [id]="field.key">
                <option *ngFor="let opt of field.options" [value]="opt.value">
                  {{ opt.label }}
                </option>
              </select>
            </ng-container>-->
          </div>

          <!-- ACTION BUTTONS -->
          <div class="display-inline d-flex">
            <button type="button" class="btn-close mr-1" (click)="deleteAction()">
              <p class="btn-save-text">{{ "projectlist.delete" | trans }}</p>
            </button>
            <button type="submit" class="btn-save ml-1" (click)="saveAction()">
              <p class="btn-save-text">{{ "projecttask.save" | trans }}</p>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>